"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
const react_virtualized_1 = require("@enykeev/react-virtualized");
const cache = new react_virtualized_1.CellMeasurerCache({
    fixedWidth: true,
    fixedHeight: true,
    defaultWidth: 390,
    defaultHeight: 239
});
exports.default = cache;
//# sourceMappingURL=cache.js.map